import { createRouter, createWebHistory } from 'vue-router'

const DEFAULT_TITLE = 'Halo 统计分析'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: () => import('@/views/DashboardPage.vue'),
      meta: { title: '数据概览' }
    },
    {
      path: '/ai-analysis',
      name: 'AIAnalysis',
      component: () => import('@/views/AIAnalysisPage.vue'),
      meta: { title: '风格分析' }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('@/views/SettingsPage.vue'),
      meta: { title: '配置' }
    }
  ]
})

router.afterEach((to) => {
  const pageTitle = to.meta.title as string | undefined
  document.title = pageTitle ? `${DEFAULT_TITLE} - ${pageTitle}` : DEFAULT_TITLE
})

export default router
